<template>
  <div style="margin-bottom:100px;">
     <table class="uk-table uk-table-striped">
      <caption>공지 사항</caption>
      <thead>
        <tr>
          <th>No.</th>
          <th>제목</th>
          <th>작성자</th>
          <th>날짜</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>긴급 인원 변경</td>
          <td>관리자</td>
          <td>2022.01.01</td>
        </tr>
        <tr>
          <td>2</td>
          <td>클라이언트 사 필독</td>
          <td>관리자</td>
          <td>2022.05.01</td>
        </tr>
        <tr>
          <td>3</td>
          <td>새해 감사 인사</td>
          <td>관리자</td>
          <td>2023.01.01</td>
        </tr>
        <tr>
          <td>4</td>
          <td>긴급 인원 변경</td>
          <td>관리자</td>
          <td>2022.01.01</td>
        </tr>
        <tr>
          <td>5</td>
          <td>클라이언트 사 필독</td>
          <td>관리자</td>
          <td>2022.05.01</td>
        </tr>
        <tr>
          <td>6</td>
          <td>새해 감사 인사</td>
          <td>관리자</td>
          <td>2023.01.01</td>
        </tr>
        <tr>
          <td>7</td>
          <td>긴급 인원 변경</td>
          <td>관리자</td>
          <td>2022.01.01</td>
        </tr>
        <tr>
          <td>8</td>
          <td>클라이언트 사 필독</td>
          <td>관리자</td>
          <td>2022.05.01</td>
        </tr>
        <tr>
          <td>9</td>
          <td>새해 감사 인사</td>
          <td>관리자</td>
          <td>2023.01.01</td>
        </tr>
      </tbody>
    </table>
    <ul class="uk-pagination uk-flex-center" uk-margin>
      <li><a href="#"><span uk-pagination-previous></span></a></li>
      <li><a href="#">1</a></li>
      <li class="uk-disabled"><span>…</span></li>
      <li><a href="#">5</a></li>
      <li><a href="#">6</a></li>
      <li class="uk-active"><span>7</span></li>
      <li><a href="#">8</a></li>
      <li><a href="#"><span uk-pagination-next></span></a></li>
    </ul>
  </div>
</template>